export default "__VITE_ASSET__fea2130b__"